import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react';

import useUser from 'src/hooks/use-user';
import useUI from 'src/hooks/use-ui';
import { useCompleteAccountModal } from 'src/components/modals/complete-account';

export const IncompleteAccountDetection = observer(
  ({ children }): JSX.Element => {
    const { open: openCompleteAccountModal } = useCompleteAccountModal();

    const { firstName, lastName, birthday, phone, loading, isLoggedIn, isSsoUser } = useUser();
    const isMissingInfo = !firstName || !lastName || !birthday || !phone;
    const isLoggedInUserMissingInfo = !loading && isLoggedIn && isMissingInfo;

    const { isEmbeddedCarousel } = useUI();
    const { route, isReady } = useRouter();

    useEffect(() => {
      if (!isReady || isEmbeddedCarousel) {
        return;
      }

      const isDutchiePayRoute = route.startsWith('/pay/');
      const isOauthRoute = route.startsWith('/oauth/');
      // We will ask consumer to complete their account info on thier phone via QR code login
      const isKioskProPublicLoginContinueRoute = route.includes('/login/public-session-continue');
      const isKioskRoute = route.startsWith('/kiosks/') && !route.includes('/login/');

      if (
        isLoggedInUserMissingInfo &&
        isSsoUser &&
        !isDutchiePayRoute &&
        !isOauthRoute &&
        !isKioskProPublicLoginContinueRoute &&
        !isKioskRoute
      ) {
        void openCompleteAccountModal();
      }
    }, [isEmbeddedCarousel, isLoggedInUserMissingInfo, isReady, isSsoUser, openCompleteAccountModal, route]);

    return children;
  }
);
